export const DeleteSVG = (color = "#FF6300") => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 3.125H8.75C8.58424 3.125 8.42527 3.05915 8.30806 2.94194C8.19085 2.82473 8.125 2.66576 8.125 2.5C8.125 2.33424 8.19085 2.17527 8.30806 2.05806C8.42527 1.94085 8.58424 1.875 8.75 1.875H11.25C11.4158 1.875 11.5747 1.94085 11.6919 2.05806C11.8092 2.17527 11.875 2.33424 11.875 2.5C11.875 2.66576 11.8092 2.82473 11.6919 2.94194C11.5747 3.05915 11.4158 3.125 11.25 3.125Z"
      fill={color}
    />
    <path
      d="M16.25 3.75H3.75C3.58424 3.75 3.42527 3.81585 3.30806 3.93306C3.19085 4.05027 3.125 4.20924 3.125 4.375C3.125 4.54076 3.19085 4.69973 3.30806 4.81694C3.42527 4.93415 3.58424 5 3.75 5H4.375V16.25C4.3755 16.7471 4.5732 17.2238 4.92472 17.5753C5.27625 17.9268 5.75287 18.1245 6.25 18.125H13.75C14.2471 18.1245 14.7238 17.9268 15.0753 17.5753C15.4268 17.2238 15.6245 16.7471 15.625 16.25V5H16.25C16.4158 5 16.5747 4.93415 16.6919 4.81694C16.8092 4.69973 16.875 4.54076 16.875 4.375C16.875 4.20924 16.8092 4.05027 16.6919 3.93306C16.5747 3.81585 16.4158 3.75 16.25 3.75ZM14.375 16.25C14.375 16.4158 14.3092 16.5747 14.1919 16.6919C14.0747 16.8092 13.9158 16.875 13.75 16.875H6.25C6.08424 16.875 5.92527 16.8092 5.80806 16.6919C5.69085 16.5747 5.625 16.4158 5.625 16.25V5H14.375V16.25Z"
      fill={color}
    />
    <path
      d="M8.125 15C7.95924 15 7.80027 14.9342 7.68306 14.8169C7.56585 14.6997 7.5 14.5408 7.5 14.375V7.5C7.5 7.33424 7.56585 7.17527 7.68306 7.05806C7.80027 6.94085 7.95924 6.875 8.125 6.875C8.29076 6.875 8.44973 6.94085 8.56694 7.05806C8.68415 7.17527 8.75 7.33424 8.75 7.5V14.375C8.75 14.5408 8.68415 14.6997 8.56694 14.8169C8.44973 14.9342 8.29076 15 8.125 15ZM11.875 15C11.7092 15 11.5503 14.9342 11.4331 14.8169C11.3158 14.6997 11.25 14.5408 11.25 14.375V7.5C11.25 7.33424 11.3158 7.17527 11.4331 7.05806C11.5503 6.94085 11.7092 6.875 11.875 6.875C12.0408 6.875 12.1997 6.94085 12.3169 7.05806C12.4342 7.17527 12.5 7.33424 12.5 7.5V14.375C12.5 14.5408 12.4342 14.6997 12.3169 14.8169C12.1997 14.9342 12.0408 15 11.875 15Z"
      fill={color}
    />
  </svg>
);

export const ViewSVG = (color = "#FF6300") => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 19 19"
    className="cursor-pointer"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6502_1490)">
      <path
        d="M15.0423 10.9074V3.95833C15.0423 3.53841 14.8755 3.13568 14.5786 2.83875C14.2816 2.54181 13.8789 2.375 13.459 2.375H5.54232C5.12239 2.375 4.71966 2.54181 4.42273 2.83875C4.1258 3.13568 3.95898 3.53841 3.95898 3.95833V15.0417C3.95898 15.4616 4.1258 15.8643 4.42273 16.1613C4.71966 16.4582 5.12239 16.625 5.54232 16.625H10.5562"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 5.54163H11.875"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 8.70837H11.875"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.125 11.875H10.2917"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g clip-path="url(#clip1_6502_1490)">
        <path
          d="M14.4257 16.6937C13.9631 16.6937 13.4853 16.5788 13.0046 16.3535C12.6281 16.1766 12.2486 15.9317 11.8767 15.6248C11.2493 15.1062 10.8623 14.5922 10.8456 14.571C10.7806 14.4848 10.7806 14.3669 10.8456 14.2807C10.8623 14.2596 11.2493 13.7455 11.8767 13.227C12.2486 12.9201 12.6281 12.6751 13.0046 12.4983C13.4853 12.273 13.9631 12.1581 14.4257 12.1581C14.8884 12.1581 15.3661 12.273 15.8469 12.4983C16.2233 12.6751 16.6028 12.9201 16.9747 13.227C17.6021 13.7455 17.9907 14.2596 18.0058 14.2807C18.0708 14.3669 18.0708 14.4848 18.0058 14.571C17.9892 14.5922 17.6021 15.1062 16.9747 15.6248C16.6028 15.9317 16.2233 16.1766 15.8469 16.3535C15.3661 16.5788 14.8884 16.6937 14.4257 16.6937ZM11.3506 14.4259C11.7301 14.8749 12.9834 16.2099 14.4257 16.2099C15.8711 16.2099 17.1214 14.8749 17.5009 14.4259C17.1214 13.9769 15.868 12.6419 14.4257 12.6419C12.9804 12.6419 11.7301 13.9769 11.3506 14.4259Z"
          fill={color}
        />
        <path
          d="M14.4264 15.5144C13.8262 15.5144 13.3379 15.026 13.3379 14.4258C13.3379 13.8256 13.8262 13.3373 14.4264 13.3373C15.0266 13.3373 15.515 13.8256 15.515 14.4258C15.515 15.026 15.0266 15.5144 14.4264 15.5144ZM14.4264 13.8211C14.0923 13.8211 13.8217 14.0917 13.8217 14.4258C13.8217 14.7599 14.0923 15.0306 14.4264 15.0306C14.7606 15.0306 15.0312 14.7599 15.0312 14.4258C15.0312 14.0917 14.7606 13.8211 14.4264 13.8211Z"
          fill={color}
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6502_1490">
        <rect width="19" height="19" fill="white" />
      </clipPath>
      <clipPath id="clip1_6502_1490">
        <rect
          width="7.74074"
          height="7.74074"
          fill="white"
          transform="translate(10.5547 10.5555)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const InfoSVG = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1C8.21997 1 6.47991 1.52784 4.99987 2.51677C3.51983 3.50571 2.36628 4.91131 1.68509 6.55585C1.0039 8.20038 0.82567 10.01 1.17294 11.7558C1.5202 13.5016 2.37737 15.1053 3.63604 16.364C4.89471 17.6226 6.49836 18.4798 8.24419 18.8271C9.99002 19.1743 11.7996 18.9961 13.4442 18.3149C15.0887 17.6337 16.4943 16.4802 17.4832 15.0001C18.4722 13.5201 19 11.78 19 10C19 7.61305 18.0518 5.32387 16.364 3.63604C14.6761 1.94821 12.3869 1 10 1ZM10 17.5C8.51664 17.5 7.06659 17.0601 5.83323 16.236C4.59986 15.4119 3.63856 14.2406 3.07091 12.8701C2.50325 11.4997 2.35473 9.99168 2.64411 8.53682C2.9335 7.08196 3.64781 5.74559 4.6967 4.6967C5.7456 3.6478 7.08197 2.9335 8.53682 2.64411C9.99168 2.35472 11.4997 2.50325 12.8701 3.0709C14.2406 3.63856 15.4119 4.59985 16.236 5.83322C17.0601 7.06659 17.5 8.51664 17.5 10C17.5 11.9891 16.7098 13.8968 15.3033 15.3033C13.8968 16.7098 11.9891 17.5 10 17.5Z"
      fill="black"
      stroke="black"
      stroke-width="0.2"
    />
    <path
      d="M9.99938 8.27449C9.80047 8.27449 9.6097 8.35351 9.46905 8.49416C9.3284 8.63481 9.24938 8.82558 9.24938 9.02449V14.1245C9.24938 14.3234 9.3284 14.5142 9.46905 14.6548C9.6097 14.7955 9.80047 14.8745 9.99938 14.8745C10.1983 14.8745 10.3891 14.7955 10.5297 14.6548C10.6704 14.5142 10.7494 14.3234 10.7494 14.1245V9.02449C10.7494 8.82558 10.6704 8.63481 10.5297 8.49416C10.3891 8.35351 10.1983 8.27449 9.99938 8.27449ZM9.99938 5.19949C9.79634 5.20713 9.60394 5.29221 9.46167 5.43727C9.3194 5.58232 9.23807 5.77635 9.23438 5.97949V6.09949C9.23402 6.19735 9.25404 6.2942 9.29317 6.3839C9.33229 6.47359 9.38965 6.55416 9.46161 6.62048C9.53357 6.68679 9.61854 6.7374 9.71113 6.76908C9.80371 6.80076 9.90188 6.81282 9.99938 6.80449C10.1959 6.79707 10.3824 6.71567 10.5215 6.57659C10.6606 6.43752 10.742 6.25103 10.7494 6.05449V5.87449C10.75 5.77917 10.7304 5.68481 10.6919 5.59761C10.6533 5.51041 10.5968 5.43236 10.5259 5.36859C10.4551 5.30482 10.3715 5.25678 10.2808 5.22764C10.19 5.19849 10.0941 5.1889 9.99938 5.19949Z"
      fill="black"
      stroke="black"
      stroke-width="0.2"
    />
  </svg>
);
